export const fakeInfoData = {
    // title: "\u54c8\u56c9\u7403\u7403 Hello ChuChu! KIDS CHANNEL",
    // channelId: "UCMNDHjn3N3-xeYvWoSqDNcQ",
    // avatar:
    //     "https://yt3.ggpht.com/a-/AAuE7mAPLVjS3mspnX3YBV5cailI_roQA_zSrFr48A=s240-mo-c-c0xffffffff-rj-k-no",
    country: "TW",
    tags: [
        "??????",
        "??????",
        "????????????",
        "???????",
        "?????????"
    ],
    topics: [
        { subject: "???? & ????", data: 11 },
        { subject: "??????", data: 9 },
        { subject: "??? & ????", data: 8 },
        { subject: "???? & ???", data: 7 },
        { subject: "?? & ????", data: 5 },
        { subject: "???? & ??", data: 4 },
        { subject: "?????", data: 3 },
        { subject: "???????", data: 2 },
        { subject: "????", data: 1 }
    ],
    // subscriberCount: 2274,
    totalViewCount: '??????',
    videoCount: '????',
    avgEngageRate: '?.?',
    subscribersRank: '????',
    monthViewRank: '????',
    monthSubscriberRank: '????',
    monthViewRateRank: '????',
    monthSubscriberRateRank: '????',
    recentAvgViewRank: '????',
    recentAvgEngageRateRank: '????',
    todaySubscriberRank: '????',
    todaySubscriberCount: '????',
    todaySubscriberRate: '?.?',
    todayViewCount: '????',
    todayViewRate: '?.?',
    monthSubscriberCount: '????',
    monthSubscriberRate: '?.?',
    monthViewCount: '??????',
    monthViewRate: '?.?',
    recentAvgViewCount: '???',
    recentAvgEngageRate: '?.?',
    recentVideos: [
        {
            title:
                "?????????????????????????????????????",
            videoId: "??????",
            viewCount: 369,
            engageRate: 1.9,
            publishAt: "????-??-??",
            cover: ""
        },
        {
            title:
                "?????????????????????????????????????",
            videoId: "??????",
            viewCount: 315,
            engageRate: 1.6,
            publishAt: "????-??-??",
            cover: ""
        },
        {
            title:
                "?????????????????????????????????????",
            videoId: "??????",
            viewCount: 234,
            engageRate: 0.9,
            publishAt: "????-??-??",
            cover: ""
        },
        {
            title:
                "?????????????????????????????????????",
            videoId: "??????",
            viewCount: 153,
            engageRate: 4.6,
            publishAt: "????-??-??",
            cover: ""
        },
        {
            title:
                "?????????????????????????????????????",
            videoId: "??????",
            viewCount: 3269,
            engageRate: 0.5,
            publishAt: "????-??-??",
            cover: ""
        },
        {
            title:
                "?????????????????????????????????????",
            videoId: "??????",
            viewCount: 98,
            engageRate: 4.1,
            publishAt: "????-??-??",
            cover: ""
        },
        {
            title:
                "?????????????????????????????????????",
            videoId: "??????",
            viewCount: 278,
            engageRate: 1.8,
            publishAt: "????-??-??",
            cover: ""
        },
        {
            title:
                "?????????????????????????????????????",
            videoId: "??????",
            viewCount: 301,
            engageRate: 1.7,
            publishAt: "????-??-??",
            cover: ""
        },
        {
            title:
                "?????????????????????????????????????",
            videoId: "??????",
            viewCount: 410,
            engageRate: 1.2,
            publishAt: "????-??-??",
            cover: ""
        },
        {
            title:
                "?????????????????????????????????????",
            videoId: "??????",
            viewCount: 148,
            engageRate: 4.7,
            publishAt: "????-??-??",
            cover: ""
        },
        {
            title:
                "?????????????????????????????????????",
            videoId: "??????",
            viewCount: 278,
            engageRate: 2.5,
            publishAt: "????-??-??",
            cover: ""
        },
        {
            title:
                "?????????????????????????????????????",
            videoId: "??????",
            viewCount: 390,
            engageRate: 2.3,
            publishAt: "????-??-??",
            cover: ""
        },
        {
            title:
                "?????????????????????????????????????",
            videoId: "??????",
            viewCount: 505,
            engageRate: 3,
            publishAt: "????-??-??",
            cover: ""
        },
        {
            title:
                "?????????????????????????????????????",
            videoId: "??????",
            viewCount: 339,
            engageRate: 2.7,
            publishAt: "????-??-??",
            cover: ""
        },
        {
            title:
                "?????????????????????????????????????",
            videoId: "??????",
            viewCount: 939,
            engageRate: 2,
            publishAt: "????-??-??",
            cover: ""
        },
        {
            title:
                "?????????????????????????????????????",
            videoId: "??????",
            viewCount: 125,
            engageRate: 2.4,
            publishAt: "????-??-??",
            cover: ""
        },
        {
            title:
                "?????????????????????????????????????",
            videoId: "??????",
            viewCount: 310,
            engageRate: 3.2,
            publishAt: "????-??-??",
            cover: ""
        },
        {
            title:
                "?????????????????????????????????????",
            videoId: "??????",
            viewCount: 78,
            engageRate: 3.8,
            publishAt: "????-??-??",
            cover: ""
        },
        {
            title:
                "?????????????????????????????????????",
            videoId: "??????",
            viewCount: 233,
            engageRate: 1.3,
            publishAt: "????-??-??",
            cover: ""
        },
        {
            title:
                "?????????????????????????????????????",
            videoId: "??????",
            viewCount: 159,
            engageRate: 5.7,
            publishAt: "????-??-??",
            cover: ""
        }
    ],
    twoMonthAvgViewCount: '?',
    twoMonthAvgEngageRate: '?.?',
    subscribersRankPercentage: '?.?',
    monthViewRankPercentage: '?.?',
    monthSubscriberRankPercentage: '?.?',
    monthViewRateRankPercentage: '?.?',
    monthSubscriberRateRankPercentage: '?.?',
    recentAvgViewRankPercentage: '?.?',
    recentAvgEngageRateRankPercentage: '?.?',
    todaySubscriberRankPercentage: '?.?',
    // pk: 14954,
    twoMonthVideos: [],
    recentViewHighest: {
        title:
            "??????????????????????????????????????????????????????",
        videoId: "??????",
        viewCount: '????????',
        engageRate: '?.?',
        publishAt: "????-??-??",
        cover: ""
    },
    recentViewLowest: {
        title:
            "?????????????????????????????????????",
        videoId: "??????",
        viewCount: '????????',
        engageRate: '?.?',
        publishAt: "????-??-??",
        cover: ""
    },
    recentEngageRateHighest: {
        title:
            "?????????????????????????????????????",
        videoId: "??????",
        viewCount: '????????',
        engageRate: '?.?',
        publishAt: "????-??-??",
        cover: ""
    },
    recentEngageRateLowest: {
        title:
            "?????????????????????????????????????????????",
        videoId: "??????",
        viewCount: '????????',
        engageRate: '?.?',
        publishAt: "????-??-??",
        cover: ""
    },
    twoMonthViewHighest: null,
    twoMonthViewLowest: null,
    twoMonthEngageRateHighest: null,
    twoMonthEngageRateLowest: null,
    weeklyPublishedVideos: '?.?'
};



// WEBPACK FOOTER //
// ./src/Info/dev/fakeInfoData.js